module.exports = __webpack_public_path__ + "img/36580-019.bd60f259.jpg";